import classNames from "classnames";
import "./filterSidebar.css";
import { Link } from "react-router-dom";
import styles from "./filterSide.module.css";

const FilterSidebar = (props) => {
  const {
    categorySidebarData,
    searchInput,
    setSearchInput,
    filtersListing,
    handleInputChange,
    categoryName,
  } = props;

  return (
    <>
      <div className="filter-body">
        <div>
          <div className="sidebar-search filter-options">
            <strong>Search</strong>
            <form>
              <input
                type="text"
                placeholder="I'm looking for"
                required
                name="search"
                value={searchInput}
                onChange={handleInputChange}
                autoComplete="off"
                disabled={!filtersListing?.length}
              />
              <input type="submit" value="" disabled />
            </form>
          </div>

          <nav role="navigation" className="accordion-menu">
            <div className={"accordion accordion-menu__list"}>
              {categorySidebarData?.category?.children.length > 0 &&
                categorySidebarData?.category?.children.map(
                  (majorCategory, idx) =>
                    majorCategory.children.length > 0 ? (
                      <div key={idx} id="accordionExample">
                        <div
                          className={classNames(styles.accordionWhole, {
                            [styles.highlight]:
                              majorCategory.url_path === categoryName,
                          })}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                            className={classNames("majorCategoryWrapper", {
                              [styles.firstCat]: idx === 0,
                            })}
                          >
                            <Link
                              to={
                                majorCategory.name.toLowerCase() !==
                                "other categories"
                                  ? `/category/${majorCategory.url_path}`
                                  : "#"
                              }
                              onClick={(e) =>
                                majorCategory?.name.toLowerCase() ===
                                  "kitchen appliances" && e.preventDefault()
                              }
                              className={"majorCategoryLink"}
                            >
                              <span className="title_heading">
                                {majorCategory.name}
                              </span>
                            </Link>
                            <button
                              className={"accordion-menu__link"}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#${majorCategory.url_path}`}
                              aria-expanded="false"
                              aria-controls={`${majorCategory.url_path}`}
                            >
                              <span className="accordion-menu__icon"></span>
                            </button>
                          </div>
                        </div>
                        <div
                          id={majorCategory.url_path}
                          className="accordion-collapse collapse"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          {majorCategory.children.length > 0 ? (
                            <div className="accordion-menu__sublist">
                              {majorCategory.children.map((subCat, index) =>
                                subCat.children.length > 0 ? (
                                  <div
                                    id={`accordionExample${subCat.id}`}
                                    key={index}
                                  >
                                    <button
                                      className={classNames(
                                        "accordion-menu__link",
                                        "subCat"
                                      )}
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target={`#${subCat.url_path}`}
                                      aria-expanded="false"
                                      aria-controls={`${subCat.url_path}`}
                                    >
                                      {subCat.name}
                                    </button>
                                    {subCat.children.map((child, idnx) => (
                                      <div
                                        id={subCat.url_path}
                                        className="accordion-collapse collapse"
                                        aria-labelledby="headingOne"
                                        data-bs-parent={`#accordionExample${subCat.id}`}
                                        key={idnx}
                                      >
                                        {child.children.length > 0 ? (
                                          <div
                                            id={`accordionExample${child.id}`}
                                            key={idnx}
                                          >
                                            <button
                                              className={classNames(
                                                "accordion-menu__link",
                                                "subChild"
                                              )}
                                              type="button"
                                              data-bs-toggle="collapse"
                                              data-bs-target={`#${child.url_path}`}
                                              aria-expanded="false"
                                              aria-controls={`${child.url_path}`}
                                            >
                                              {child.name}
                                            </button>
                                            <div
                                              id={child.url_path}
                                              className="accordion-collapse collapse"
                                              aria-labelledby="headingOne"
                                              data-bs-parent={`#accordionExample${child.id}`}
                                              key={idnx}
                                            >
                                              {child.children.map(
                                                (subChild, subIdx) => (
                                                  <Link
                                                    to={`/category/${subChild.url_path}`}
                                                    className="accordion-menu__sublink"
                                                    key={subIdx}
                                                  >
                                                    {subChild.name}
                                                  </Link>
                                                )
                                              )}
                                            </div>
                                          </div>
                                        ) : (
                                          <Link
                                            to={`/category/${child.url_path}`}
                                            className="accordion-menu__sublink"
                                          >
                                            {child.name}
                                          </Link>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  subCat.name.toLowerCase() !== "deals" &&
                                  subCat.name.toLowerCase() !== "bestsellers" &&
                                  subCat.name.toLowerCase() !== "summer sale" &&
                                  subCat.name.toLowerCase() !==
                                    "magical summer sale" && (
                                    <Link
                                      className="accordion-menu__sublink"
                                      to={`/category/${majorCategory.url_path}/${subCat.url_key}`}
                                      key={index}
                                    >
                                      {subCat.name}
                                    </Link>
                                  )
                                )
                              )}
                            </div>
                          ) : (
                            <p></p>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className={styles.accordionLinkWrapper}>
                        <div
                          className={classNames("accordion-menu__link", {
                            [styles.highlight]:
                              categoryName === majorCategory.url_path,
                            [styles.firstCat]: idx === 0,
                          })}
                          key={idx}
                        >
                          <Link
                            to={`/category/${majorCategory.url_path}`}
                            className="title_heading"
                          >
                            {majorCategory.name}
                          </Link>
                        </div>
                      </div>
                    )
                )}
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default FilterSidebar;
